import { Component, OnInit, Output, EventEmitter, Input, HostListener, ViewChildren, Query, QueryList, ElementRef, ViewChild, AfterViewChecked, AfterContentInit, AfterContentChecked, AfterViewInit } from '@angular/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { DirectionsService } from 'src/app/services/directions.service';
import { ɵELEMENT_PROBE_PROVIDERS } from '@angular/platform-browser';

/**
 * Component encarregat de donar a l'usuari opcions per cercar ubicacions i seleccionar els submenús disponibles
 */
@Component({
  selector: 'app-cercador-switch',
  templateUrl: './cercador-switch.component.html',
  styleUrls: ['./cercador-switch.component.css']
})
export class CercadorSwitchComponent implements OnInit, AfterViewInit{

  /**
   * @ignore
   */
  searchText: string = ""; 

  /**
   * @ignore
   */
  rutaTrobada: boolean = true;
  
  /**
   * Límits del mapa per mostrar Espanya i les Illes Canàries
   */
  espLatLngBounds = new  google.maps.LatLngBounds(
    new google.maps.LatLng(26.709041066163724, -20.306056689891875),
    new google.maps.LatLng(44.811251049443776, 5.182224560108125)  
  );

  /**
   * Instància del mapa de l'aplicació
   */
  @Input() map: google.maps.Map;


  /**
   * Finestra d'informació provinent del mapa map
   */
  @Input() infowindow: google.maps.InfoWindow;

  /**
   * Llista d'incidències visibles al mapa 
   */
  @Input() set setLlistaIncidencies(value) {
    this.llistaIncidencies = value;
  }


  /**
   * Emet els valors de les ubicacions de les rutes
   */
  @Output() directionsEmitter = new EventEmitter<string[]>();

  /**
   * Emet un indicador de que s'ha fet la cerca d'una ubicació
   */
  @Output() searchEmitter = new EventEmitter<any>();

  /**
   * Conté tots els marcadors d'incidències presents al mapa
   */
  llistaIncidencies; 

  /**
   * @ignore
   */
  @ViewChildren('search') searchElements: QueryList<ElementRef>;

  /**
   * @ignore
   */
  @ViewChild('searchFocus') searchFocus: ElementRef;

  /**
   * @ignore
   */
  @HostListener('window:resize')
  onResize() {
    this.setScreenMode();
    
  }

  /**
   * Retorna la llista d'incidències visibles al mapa
   */
  get getLlistaIncidencies(){
    return this.llistaIncidencies;
  }

  /**
   * Noms dels submenus disponibles
   */
  submenus = ["rutes", "alertes", "serveis"];

  /**
   * Subemenú seleccionat
   */
  selectedSubmenu = "";

  /**
   * Indica si s'ha fet el càlcul o no d'una ruta
   */
  rutaCalculada: boolean = false;

  /**
   * Indica si l'usuari vol veure els detalls de la ruta (només per mòbil horitzontal)
   */
  showRouteDetails: boolean = false;

  /**
   * Indica el mode seleccionat per l'usuari per calcular la ruta
   */
  directionsMode: string = "";

  /**
   * Indica en què mode es troba la pantalla (escriptori, mòbil vertical o mòbil horitzontal)
   */
  screenMode: string = '';

  /**
   * Indica l'altura de la pantalla
   */
  screenHeight: number = 100; 

  /**
   * Indica l'amplada de la pantalla
   */
  screenWidth: number = 100;

  /**
   * S'executa quan es selecciona un dels submenús i l'obre o el tanca en funció de l'estat actual
   * @param {string} submenu Nom del submenú escollit
   */
  onSelect(submenu: string): void {
    if(submenu===this.selectedSubmenu) this.selectedSubmenu = "";
    else{
      this.selectedSubmenu = submenu;
      if(this.selectedSubmenu === 'cerca'){
        setTimeout(() => {
          this.searchFocus.nativeElement.focus();
        },0)
        
      }
    } 
  }

  
  /**
   * Canvia la propietat `screenMode` d'acord amb la mida de la pantalla de l'usuari
   */
  setScreenMode(): void{
    this.screenHeight = window.innerHeight;
    this.elementRef.nativeElement.style.setProperty('--height',this.screenHeight + 'px');
    this.screenWidth = window.innerWidth;
    this.elementRef.nativeElement.style.setProperty('--width',this.screenWidth + 'px');
    if(window.innerWidth < 568)
      this.screenMode = 'portrait';
    else if(window.innerWidth < 824)
      this.screenMode = 'landscape';
    else 
      this.screenMode = 'desktop';
  }

  /**
   * Fa la petició als servidors de rutes per calcular les rutes donats una sèrie de waypoints
   * @param {string[]} waypoints texts que contenen les ubicacions per les quals passa la ruta que vol calcular l'usuari 
   */
  onEventDirections(waypoints: string[]){
    this.rutaTrobada = true;
    this.directionsEmitter.emit(waypoints);
    this.rutaCalculada = true;
    this.showRouteDetails = true;
    var resultat;
    if(this.directionsMode === 'evitaPeatges') resultat = this.directionsService.getShortestRoute(waypoints, true);
    else if(this.directionsMode === 'mesRapidaTrafic') resultat = this.directionsService.getInrixShortestRoute(waypoints);
    else resultat = this.directionsService.getShortestRoute(waypoints,false)
    if(resultat.length === 0) this.rutaTrobada = false;
  }

  /**
   * Canvia el mode de càlcul de ruta
   * @param {tring} newOption opció escollida per l'usuari
   */
  onEventDirectionsOption(newOption: string){
    this.directionsMode = newOption;
  }

  /**
   * Activa o desactiva la informació de rutes al mapa
   * @param event boolean indicant si s'activa o desactiva la informació sobre rutes al mapa
   */
  onEventToggleDirections(event: boolean){
    this.rutaCalculada = event;
    if(event === false) this.directionsService.deleteDirections();
  }

  /**
   * Quan es detecta un canvi d'ubicació en l'autocompletat de Google Maps, s'emet la ubicació d'aquest al mapa
   * @param {google.maps.places.Autocomplete} autocomplete objecte d'autocompletat de Google Maps
   */
  onPlaceChanged(autocomplete: google.maps.places.Autocomplete){
    var place = autocomplete.getPlace();
    if(place.geometry){
      this.searchEmitter.emit(place.geometry)
    }
  }

  /**
   * Inicialitza el servei d'autocompletat dels inputs 
   */
  setSearchAutocomplete(): void {
    var elements= document.getElementsByClassName("search");
    for(var i = 0; i < elements.length; i++){
      var inputElement: HTMLInputElement = <HTMLInputElement>elements[i];
      let autocomplete = new google.maps.places.Autocomplete(inputElement, {bounds: this.espLatLngBounds});
      autocomplete.addListener('place_changed', () => this.onPlaceChanged(autocomplete));
    }
  }

  /**
   * Indica al servei de rutes quin és el preu per kilòmetre
   * @param {number} preuKm preu per kilòmetre calculat a partir dels paràmetres introduits per l'usuari
   */
  setPreuKm(preuKm: number){
    this.directionsService.setPreuKm(preuKm);
  }

  /**
   * Constructor del component
   * @param {DirectionsService} directionsService Servei de rutes
   * @param {ElementRef} elementRef Serveix per mantenir referències a elements de la plantilla del component
   */
  constructor(private directionsService: DirectionsService, private elementRef: ElementRef) { }

  /**
   * Inicialitza el mode de pantalla i els serveis d'autocompletat 
   */
  ngOnInit() {
    this.setScreenMode();
    this.setSearchAutocomplete();
  }
  
  /**
   * Escolta els canvis en els elements de la plantilla que serveixen per fer cerques d'ubicacions
   */
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.searchElements.changes.subscribe( r => {
      this.setSearchAutocomplete();
    })
  }
  

}
